import styled from 'styled-components';
import getThemeByProps from '@userzoomlibraries/toolkit-theme-manager/get-theme-by-props';
import React, { useState, useRef, useMemo, useCallback, useEffect, Fragment } from 'react';
import PropTypes from '@userzoomlibraries/toolkit-js-utils/prop-types';
import noop from '@userzoomlibraries/toolkit-js-utils/noop';
import getId from '@userzoomlibraries/toolkit-js-utils/get-id';
import isDefinedAndNotNull from '@userzoomlibraries/toolkit-js-utils/is-defined-and-not-null';
import useDataAttributes from '@userzoomlibraries/toolkit-react-utils/use-data-attributes';
import { P as PLACEMENTS, C as Container } from './index.styled2.js';
import { I as Input } from './index.styled7.js';
import { W as Wrapper } from './index.styled3.js';
import { C as Checkmark } from './index.styled4.js';
import { I as IndeterminateMark } from './index.styled5.js';
import { L as Label } from './index.styled6.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["id", "as", "className", "name", "defaultChecked", "checked", "disabled", "invalid", "indeterminate", "children", "placement", "onChange", "onFocus", "onBlur"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Checkbox$1 = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var id = _ref.id,
      AsComponent = _ref.as,
      className = _ref.className,
      name = _ref.name,
      defaultChecked = _ref.defaultChecked,
      checked = _ref.checked,
      disabled = _ref.disabled,
      invalid = _ref.invalid,
      indeterminate = _ref.indeterminate,
      children = _ref.children,
      placement = _ref.placement,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFocused = _useState2[0],
      setIsFocused = _useState2[1];

  var dataAttributes = useDataAttributes(otherProps, {
    excludedAttributes: ['data-checked', 'data-indeterminate', 'data-disabled', 'data-invalid', 'data-focused']
  });
  var checkboxId = useRef(id || "gz-checkbox-".concat(getId()));
  var checkboxInputId = useRef("".concat(checkboxId.current, "-input"));
  var checkboxLabelId = useRef("".concat(checkboxId.current, "-label"));

  var _useState3 = useState(function () {
    if (isDefinedAndNotNull(defaultChecked)) {
      return defaultChecked;
    }

    if (isDefinedAndNotNull(checked)) {
      return checked;
    }

    return false;
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      stateChecked = _useState4[0],
      setStateChecked = _useState4[1];

  var isControlledCheckbox = useMemo(function () {
    if (isDefinedAndNotNull(defaultChecked) && !isDefinedAndNotNull(checked)) {
      return false;
    }

    if (!isDefinedAndNotNull(defaultChecked) && isDefinedAndNotNull(checked)) {
      return true;
    }

    if (!isDefinedAndNotNull(defaultChecked) && !isDefinedAndNotNull(checked)) {
      return false;
    }

    console.error("Warning: ".concat(Checkbox$1.displayName, " contains an input with both checked and defaultChecked props.\n      Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both).\n      Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components"));
    return false;
  }, [checked, defaultChecked]);
  var onChangeHandler = useCallback(function (event) {
    var newChecked = !stateChecked;

    if (!isControlledCheckbox) {
      setStateChecked(newChecked);
    }

    onChange({
      checked: newChecked,
      name: name,
      event: event
    });
  }, [name, stateChecked, isControlledCheckbox, onChange]);
  var onFocusHandler = useCallback(function (event) {
    if (!disabled) {
      setIsFocused(true);
      onFocus(event);
    }
  }, [onFocus, disabled]);
  var onBlurHandler = useCallback(function (event) {
    setIsFocused(false);
    onBlur(event);
  }, [onBlur]);
  useEffect(function () {
    setStateChecked(function (prevState) {
      var newStateChecked = prevState;

      if (isDefinedAndNotNull(defaultChecked)) {
        newStateChecked = defaultChecked;
      }

      if (isDefinedAndNotNull(checked)) {
        newStateChecked = checked;
      }

      return newStateChecked;
    });
  }, [defaultChecked, checked]);
  var classnamesArray = ['gz-checkbox'];

  if (stateChecked) {
    classnamesArray.push('gz-checkbox--checked');
  }

  if (disabled) {
    classnamesArray.push('gz-checkbox--disabled');
  }

  if (invalid) {
    classnamesArray.push('gz-checkbox--invalid');
  }

  if (indeterminate) {
    classnamesArray.push('gz-checkbox--indeterminate');
  }

  classnamesArray = [].concat(_toConsumableArray(classnamesArray), [className]);
  var classnames = classnamesArray.join(' ');
  return /*#__PURE__*/jsxs(Container, _objectSpread(_objectSpread({
    id: checkboxId.current,
    ref: ref,
    className: classnames,
    placement: placement,
    onFocus: onFocusHandler,
    onBlur: onBlurHandler,
    "data-checked": stateChecked,
    "data-disabled": disabled,
    "data-invalid": invalid,
    "data-indeterminate": indeterminate,
    "data-focused": isFocused // eslint-disable-next-line react/jsx-props-no-spreading

  }, dataAttributes), {}, {
    children: [/*#__PURE__*/jsx(Input, {
      id: checkboxInputId.current,
      name: name,
      defaultChecked: stateChecked,
      disabled: disabled,
      invalid: invalid,
      onChange: onChangeHandler,
      "aria-labelledby": checkboxLabelId.current
    }), isDefinedAndNotNull(AsComponent) ? /*#__PURE__*/jsx(AsComponent, _objectSpread(_objectSpread({
      checkboxId: checkboxId.current,
      checkboxInputId: checkboxInputId.current,
      checkboxLabelId: checkboxLabelId.current,
      placement: placement,
      indeterminate: indeterminate,
      checked: stateChecked,
      disabled: disabled,
      invalid: invalid
    }, otherProps), {}, {
      children: children
    })) : /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(Wrapper, {
        indeterminate: indeterminate,
        children: indeterminate ? /*#__PURE__*/jsx(IndeterminateMark, {}) : /*#__PURE__*/jsx(Checkmark, {})
      }), children && /*#__PURE__*/jsx(Label, {
        id: checkboxLabelId.current,
        htmlFor: checkboxInputId.current,
        placement: placement,
        children: children
      })]
    })]
  }));
});
Checkbox$1.COMPONENT_ID = 'Gearz.Checkbox';
Checkbox$1.displayName = Checkbox$1.COMPONENT_ID;
Checkbox$1.IndeterminateMark = IndeterminateMark;
Checkbox$1.Checkmark = Checkmark;
Checkbox$1.PLACEMENTS = PLACEMENTS;
Checkbox$1.propTypes = {
  id: PropTypes.stringWithDescription('Id of the checkbox.'),
  as: PropTypes.elementTypeWithDescription('Component to be used as checkbox. (use forwardedAs)'),
  className: PropTypes.stringWithDescription('Custom class to be applied.'),
  name: PropTypes.stringWithDescription('Name of the checkbox.'),
  defaultChecked: PropTypes.boolWithDescription('Initial checked state of the checkbox. (uncontrolled)'),
  checked: PropTypes.boolWithDescription('Flag to check the checkbox. (controlled)'),
  disabled: PropTypes.boolWithDescription('Flag to make the checkbox disable.'),
  invalid: PropTypes.boolWithDescription('Flag to make the checkbox invalid.'),
  indeterminate: PropTypes.boolWithDescription('Flat to make the checkbox indeterminate.'),
  children: PropTypes.nodeWithDescription('Content of the checkbox.'),
  placement: PropTypes.oneOfWithDescription(Object.values(PLACEMENTS), 'Placement of the label of the checkbox.'),
  onChange: PropTypes.funcWithDescription('Callback called when the value of the checkbox is changed. (checked/unchecked)'),
  onFocus: PropTypes.funcWithDescription('Callback called when focus event is triggered.'),
  onBlur: PropTypes.funcWithDescription('Callback called when blur event is triggered.')
};
Checkbox$1.defaultProps = {
  id: null,
  as: null,
  className: '',
  name: null,
  defaultChecked: undefined,
  checked: undefined,
  disabled: false,
  invalid: false,
  indeterminate: false,
  children: null,
  placement: PLACEMENTS.RIGHT,
  onChange: noop,
  onFocus: noop,
  onBlur: noop
};

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var Checkbox = styled(Checkbox$1).withConfig({
  componentId: "gz-checkbox-1679041957665__sc-gmdq6l-0"
})(["", ""], function (props) {
  return getThemeByProps({
    componentId: Checkbox$1.COMPONENT_ID,
    props: props
  });
});
Checkbox.displayName = Checkbox$1.displayName;
Checkbox.propTypes = Checkbox$1.propTypes;
Checkbox.defaultProps = Checkbox$1.defaultProps;

export { Checkbox as C };
